import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Router from "..";

export const useSearchInfluencers = ({
  page = 1,
  follower = null,
  keyword = null,
  category = null,
  sort = "follower",
  region = null,
  gender = null,
}) => {
  return useQuery({
    queryKey: [
      "searchInfluencers",
      page,
      follower,
      keyword,
      category,
      sort,
      region,
      gender,
    ],
    queryFn: () =>
      Router.Api.searchInfluencers({
        page,
        follower,
        keyword,
        category,
        sort,
        region,
        gender,
      }),
    staleTime: 1000 * 60,
  });
};

export const useInfluencerDetail = ({
  unique_id,
  enabled = true,
  onInvalidUser,
}) => {
  return useQuery({
    queryKey: ["influencerDetail", unique_id],
    queryFn: () => Router.Api.getInfluencerDetail(unique_id),
    enabled: !!unique_id && enabled,
    onError: (err) => {
      const msg = err.message;

      if (msg === "탈퇴했거나 유효하지 않은 크리에이터 정보입니다.") {
        onInvalidUser?.();
      }
    },

    staleTime: 1000 * 60 * 5,
  });
};

export const useInfluencerDetailCached = ({
  unique_id,
  enabled = true,
  onInvalidUser,
}) => {
  return useQuery({
    queryKey: ["influencerDetailCached", unique_id],
    queryFn: () => Router.Api.getInfluencerDetailCached(unique_id),
    enabled: !!unique_id && enabled,
    onError: (err) => {
      const msg = err.message;

      if (msg === "탈퇴했거나 유효하지 않은 크리에이터 정보입니다.") {
        onInvalidUser?.();
      }
    },

    staleTime: 1000 * 60 * 5,
  });
};

export const useAnalyzeAiResult = ({ unique_id, enabled = true }) => {
  return useQuery({
    queryKey: ["analyzeAiResult", unique_id],
    queryFn: () => Router.Api.analyzeAiResult(unique_id),
    enabled: !!unique_id && enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export const useAnalyzeAiBrandFit = ({ unique_id, enabled = true }) => {
  return useQuery({
    queryKey: ["analyzeAiBrandFit", unique_id],
    queryFn: () =>
      Router.Api.analyzeAiBrandFit({ unique_id, is_update: false }),
    enabled: !!unique_id && enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdateAiBrandFit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ unique_id }) =>
      Router.Api.analyzeAiBrandFit({
        unique_id,
        is_update: true,
      }),

    onSuccess: (_, { unique_id }) => {
      queryClient.invalidateQueries({
        queryKey: ["analyzeAiBrandFit", unique_id],
      });
    },
  });
};

export const useRecommendInfluencers = (
  { follower, keyword, category, region, gender },
  enabled = false
) => {
  return useQuery({
    queryKey: [
      "recommendedInfluencers",
      follower,
      keyword,
      category,
      region,
      gender,
    ],
    queryFn: () =>
      Router.Api.getRecommendedInfluencers(
        follower,
        keyword,
        category,
        region,
        gender
      ),
    enabled,
    staleTime: 1000 * 60 * 10,
  });
};
